<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">
        <h1>
            <p class="text-sm-left font-weight-bold">Cadastrar Unidade</p>
          <!-- {{recepcionista}} -->
        </h1>
      {{nomeUnidade}}
      <v-flex row wrap mt-3 px-5>
        <v-form v-model="valid" ref="form">
          <!-- <v-text-field
      label="Name"
      v-model="name"
      :rules="nameRules"
      :counter="10"
      required
    ></v-text-field> -->
          <!-- <v-text-field
      label="E-mail"
      v-model="email"
      :rules="emailRules"
      required
    ></v-text-field> -->
          <v-text-field v-model="nomeUnidade" :rules="nomeRules" :type="'text'" name="input-10-1" label="Nome da unidade" counter @click:append="show1 = !show1"></v-text-field>

          <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Voce deve concordar para cadastrar']" required></v-checkbox>
          <v-alert :value="erroEditar" color="error" icon="warning" outlined>
            Erro ao editar nome !!
          </v-alert>

          <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
            Sucesso ao cadastrr unidade!!
          </v-alert>

          <v-btn @click="cadastrarUnidade" :class="{ red: !valid, green: valid }">cadastrar</v-btn>
          <v-btn @click="clear">limpar</v-btn>
        </v-form>

      </v-flex>
    </v-card>
  </v-layout>
  <!-- <v-layout  row wrap >
   <v-flex x12>
     <v-flex xs10 offset-xs1>
          lista de servicos
     </v-flex>
    </v-flex>
</v-layout>  -->

</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorService from '../../../services/administrador.service'
// import EventBus from '../../../main';

export default {
  name: 'cadastrarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: false,
      sucessoEditar: false,
      isEditing: true,
      nomeUnidade: '',
      valid: false,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 5 || 'Nome da unidade deve ter 6 ou mais caracteres'
      ]
    }
  },
  mounted () {
    console.log('em mouted')
    this.user = this.$store.getters.usuario
    this.erroEditar = false,
    this.sucessoEditar = false
  },
  methods: {

    cadastrarUnidade () {
      if (this.$refs.form.validate()) {
        console.log('em alterarNomeUnidade')

        administradorService.administrador
          .cadastrarUnidade(this.nomeUnidade)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data.msg)
            if (rsp.data.msg == 'erro') {
              this.erroEditar = true
            }
            if (rsp.data.msg == 'true') {
              // this.$router.push("/listaUnidade");
              this.idUnidade = null,
              this.sucessoEditar = true
              this.clear()
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    clear () {
      this.$refs.form.reset()
    }

  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
